import "primevue/resources/themes/mdc-light-indigo/theme.css"
import "primevue/resources/primevue.min.css"
import "primeicons/primeicons.css"

import App from "./App.vue"
import { createApp, Directive, markRaw } from "vue"

import i18n from "./i18n/index"
import PrimeVue from "primevue/config"
import router from "./router"
import StyleClass from "primevue/styleclass"

import configurarSentry from "./configs/sentry/sentry"

import Skeleton from "primevue/skeleton"
import Button from "primevue/button"
import Toast from "primevue/toast"
import Tooltip from "primevue/tooltip"
import TabMenu from "primevue/tabmenu"

import Permissionamento from "./directives/permissionamento"

import ConfirmationService from "primevue/confirmationservice"
import ToastService from "primevue/toastservice"

import { createPinia } from "pinia"
import { FilterMatchMode } from "primevue/api"

import { usarIdiomaDoNavegador } from "./composable/UsarIdiomaDoNavegador/usarIdiomaDoNavegador"
import inicializarClarity from "@/servicos/clarity.js"
import { idiomas } from "./configs/locales"
import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
import SessaoServico from "@/servicos/sessao.service"
import { processarCallbackKeycloak } from "@/servicos/keycloak.service"
import { adaptarUsuarioLogadoParaSessao } from "@/servicos/autenticacao.service"

const { definirIdioma } = usarIdiomaDoNavegador()

async function iniciarAplicacao(): Promise<void> {
  await processarCallbackKeycloak()
  inicializarClarity()

  const app = createApp(App)

  app.directive("styleclass", StyleClass)
  app.directive("tooltip", Tooltip)
  app.directive("permissionamento", Permissionamento as Directive<any, any>)

  configurarSentry(app)

  app.component("Skeleton", Skeleton)
  app.component("PButton", Button)
  app.component("Toast", Toast)
  app.component("TabMenu", TabMenu)

  const pinia = createPinia()
  pinia.use(({ store }) => {
    store.$router = markRaw(router)
  })

  if (SessaoServico.autenticado) {
    const usuariosRepositorio = new UsuariosRepositorio()
    SessaoServico.iniciarCarregamentoDoUsuarioLogado(
      async () =>
        adaptarUsuarioLogadoParaSessao(
          await usuariosRepositorio.obterUsuarioLogado()
        )
    )
    await SessaoServico.aguardarCarregamentoDoUsuarioLogado()
  }

  app
    .use(PrimeVue, {
      inputStyle: "filled",
      locale: idiomas[definirIdioma()],
      zIndex: {
        modal: 1100, //dialog, sidebar
        overlay: 1200, //dropdown, overlaypanel
        menu: 1000, //overlay menus
        tooltip: 1100, //tooltip
      },
      filterMatchModeOptions: {
        text: [
          FilterMatchMode.CONTAINS,
          FilterMatchMode.EQUALS,
          FilterMatchMode.NOT_EQUALS,
        ],
        numeric: [
          FilterMatchMode.EQUALS,
          FilterMatchMode.NOT_EQUALS,
          FilterMatchMode.LESS_THAN,
          FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
          FilterMatchMode.GREATER_THAN,
          FilterMatchMode.GREATER_THAN_OR_EQUAL_TO,
        ],
        date: [
          FilterMatchMode.DATE_IS,
          FilterMatchMode.DATE_IS_NOT,
          FilterMatchMode.DATE_BEFORE,
          FilterMatchMode.DATE_AFTER,
        ],
        dropdown: [
          FilterMatchMode.IN,
          FilterMatchMode.NOT_EQUALS,
          FilterMatchMode.EQUALS,
        ],
        multiselect: [FilterMatchMode.IN],
      },
    })
    .use(ToastService)
    .use(ConfirmationService)
    .use(i18n as any)
    .use(pinia)
    .use(router)
    .mount("#app")
}

void iniciarAplicacao()
